import { authRequest } from "src/engine/modules/authRequest"
import { showToast } from "@infotech/uikit-toasts"
import get from "lodash/get"

export const createNewStatus = ({
  formValue,
  close,
  setErrors,
  readAllStatuses,
}) => {
  authRequest({
    url: `/statuses`,
    method: `post`,
    data: formValue,
  })
    .then(response => {
      showToast({
        type: `success`,
        message: `Статус "${get(response, `data.name`)}" создан`,
        hideIn: 5,
      })
      readAllStatuses()
      close()
    })
    .catch(error => {
      if (error) {
        showToast({
          type: `error`,
          message: get(error, `response.data.exception`) || `Unknown error`,
          hideIn: 5,
        })
      }
      setErrors(get(error, `response.data.body`))
    })
}
